module.exports = "<div class=\"signupPage\">\r\n    <wow-signup-form class=\"signupPage-form\"></wow-signup-form>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/auth/signup/signup-page.component.html
// module id = 61
// module chunks = 0 2